

module.exports = __webpack_require__.stylable.create(
    "SearchResuts3400210420",
    {"classes":{"root":"SearchResuts3400210420__root","contentWrapper":"SearchResuts3400210420__contentWrapper","content":"SearchResuts3400210420__content","paginationWrapper":"SearchResuts3400210420__paginationWrapper"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    16,
    "SearchResuts3400210420",
    null
);
